import { gql } from "@apollo/client";
import { TerminalTypesInfo } from "./getTerminalTypesCall";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const PANEL_CREATE_SECTION = gql`
  mutation CreateSection($domain: String!, $sectionName: String!, $panelSectionType: Int!, $systemId: Int!, $section: [CreateLocation!]!, $terminalLinks: [CreateTerminalLink!]) {
    section {
      create(domain: $domain, sectionName: $sectionName, panelSectionType: $panelSectionType, systemId: $systemId, section: $section, terminalLinks: $terminalLinks) {
        code
        success
        message
        updatedValues
      }
    }
  }
`

export interface CreateStation {
  name: string;
  visual: string;
  terminals: { device_id: number, terminal_type?: number | null, config?: Omit<TerminalTypesInfo, "input">, port: number }[];
  station_type: number
}
export interface CreatePanelLocation {
  location_name: string;
  visual: string;
  stations: CreateStation[];
}

export interface CreateTerminalLink {
  device_id: number;
  port: number;
  next_device_id?: number;
  next_port?: number;
  parent_device_id?: number;
  parent_port?: number;
}

export interface CreatePanelLocationResponse {
  section: {
    create: Response;
  }
}

interface Response extends Def_MutationResponse {
  updatedValues?: number[]
}

export const PANEL_MAINTAIN_SECTION = gql`
  mutation Maintain($domain: String!, $sectionRenames: [RenameSection!]!, $locationRenames: [RenameLocation!]!, $terminalChanges: [UpdateTerminal!]!, $stationRenames: [RenameStation!]!) {
    section {
      maintain(domain: $domain, sectionRenames: $sectionRenames, locationRenames: $locationRenames, terminalChanges: $terminalChanges, stationRenames: $stationRenames) {
        code
        success
        message
        errorColumns {
          key
          value
        }
        updatedValues {
          updatedSections {
            section_id
            name
          }
          updatedLocations {
            location_id
            name
          }
          updatedTerminals {
            terminal_id
            port
            fk_devices
            programmed
            fk_components
            sensor_p
          }
          updatedStations {
            station_id
            name
          }
        }
      }
    }
  }
`

export interface MaintainPanelSectionResponse {
  section: {
    maintain: Def_MutationResponse & {
      updatedValues: {
        updatedLocations: UpdatedLocations[],
        updatedSections: UpdatedSections[],
        updatedTerminals: UpdatedTerminal[],
        updatedStations: UpdatedStation[],
      },
      errorColumns?: {
        key: string
        value: string
      }
    };
  }
}

export interface MaintainPanelSectionParameters {
  domain: string,
  sectionRenames: RenameSection[],
  locationRenames: RenameLocation[],
  terminalChanges: UpdateTerminal[],
  stationRenames: RenameStation[]
}

export interface UpdateTerminal {
  configProgrammed?: number,
  fk_devices?: number,
  port?: number,
  terminal_id: number,
  fk_components?: number
  sensor_p?: number
}

export interface RenameSection {
  new_name: string
  section_id: number
}

export interface RenameLocation {
  location_id: number
  new_name: string
}

export interface UpdatedTerminal {
  terminal_id: number,
  port?: number,
  fk_devices?: number,
  programmed?: number,
  fk_components?: number,
  sensor_p?: number,
}

interface UpdatedStation {
  station_id: number,
  name: string
}

export interface RenameStation {
  station_id: number
  new_name: string
}

interface UpdatedLocations {
  location_id: number,
  name: string
}

interface UpdatedSections {
  section_id: number,
  name: string
}

export const REORDER_SECTION = gql`
  mutation ReorderSection($domain: String!, $sectionReorders: [SectionReorder!]!) {
    section {
      reorder(domain: $domain, sectionReorders: $sectionReorders) {
        code
        success
        message
        updatedValues {
          section_id
          section_order
        }
      }
    }
  }
`

export type SectionReorder = {
  section_id: number,
  section_order: number,
}

export interface ReorderSectionResponse {
  section: {
    reorder: {
      code: string;
      success: boolean;
      message: string;
      updatedValues: SectionReorder[];
    }
  }
}
